const authenticate = (logged: boolean) => {
  try {
    if (logged) {
      document.body.classList.remove("session-guest");
      document.body.classList.add("session-user");
    } else {
      document.body.classList.remove("session-user");
      document.body.classList.add("session-guest");
    }
  } catch (e) {
    return;
  }
};

const initSession = () => {
  const iframe = document.createElement("iframe");
  iframe.src = `${CONFIG.ssoHost}/session`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  window.addEventListener("message", event => {
    if (event.origin === CONFIG.ssoHost) {
      authenticate(event.data.loggedIn);
    }
  });
};

document.addEventListener("DOMContentLoaded", initSession);
